import { api, writeDB } from './store';
import { Image } from './asset';

/* INTERFACES */
export interface Logo {
  id: string;
  tags: string[];
  image: Image;
}

/* LOGOS CREATE */
export async function addLogo(image: string, tags: string[]): Promise<void> {
  const response = (await api.createLogo({ image, tags })).data;
  writeDB.table('logos').upsert(response);
}

/* LOGOS READ */
export async function getLogos(): Promise<void> {
  if (writeDB.table('logos').ids.length > 0) {
    return;
  }
  const response = (await api.indexLogos()).data;
  if (response) {
    writeDB.table('logos').upsert(response);
  }
}

/* LOGOS UPDATE */
/* LOGOS DELETE */
